import { jwtDecode } from "jwt-decode";
import { createContext, useEffect, useReducer } from "react";
import AuthApi from "../apis/auth.api";
import { LOCAL_STORAGE_KEYS } from "../constants/AppConstants";
import LocalUtils from "../utils/localUtils";

const initialState = {
  isAuthenticated: false,
  user: null,
  ceoInfo: null,
  isInitialized: false,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, ceoInfo } = action.payload;
    return {
      ...state,
      isAuthenticated,
      ceoInfo,
      user,
      isInitialized: true,
    };
  },
  LOGIN: (state, action) => {
    const { user, ceoInfo } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      ceoInfo,
      user,
    };
  },

  REGISTER: (state, action) => {
    const { user, ceoInfo } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      ceoInfo,
      user,
    };
  },

  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    ceoInfo: null,
  }),
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  method: "jwt",
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  verity: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken =
          LocalUtils.get(LOCAL_STORAGE_KEYS.ACCESS_TOKEN) || "";
        const ceoInfo =
          JSON.parse(LocalUtils.get(LOCAL_STORAGE_KEYS.CEO_INFO)) || "";

        if (accessToken) {
          const user = jwtDecode(accessToken);
          dispatch({
            type: "INITIALIZE",
            payload: {
              isAuthenticated: true,
              user,
              ceoInfo,
            },
          });
        } else {
          dispatch({
            type: "INITIALIZE",
            payload: {
              isAuthenticated: false,
              user: null,
              ceoInfo: null,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: "INITIALIZE",
          payload: {
            isAuthenticated: false,
            user: null,
            ceoInfo: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (submitData) => {
    const { data } = await AuthApi.login(submitData);

    if (data?.data?.access_token) {
      const user = jwtDecode(data.data.access_token);
      LocalUtils.set(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, data.data.access_token);
      LocalUtils.set(LOCAL_STORAGE_KEYS.CEO_INFO, JSON.stringify(data.data));
      dispatch({
        type: "LOGIN",
        payload: {
          user: user,
          ceoInfo: data.data,
        },
      });
    }
    return data
  };

  const logout = async () => {
    const { data } = await AuthApi.logout();
    dispatch({ type: "LOGOUT" });
    LocalUtils.clearAuthenticationInfo();
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "jwt",
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
